import { Base } from '@studiometa/js-toolkit';

/**
 * DyslexiaInput component
 */
export default class DyslexiaInput extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'DyslexiaInput',
  };

  /**
   * isDarkMode
   * @returns {string}
   */
  get isDyslexiaMode() {
    return localStorage.getItem('dyslexia') === '1';
  }

  /**
   * mounted
   */
  mounted() {
    if (this.isDyslexiaMode) {
      this.$el.checked = true;
      document.body.classList.add('dyslexia');
      document.documentElement.style.setProperty('--font-size-1', '0.8rem');
      document.documentElement.style.setProperty('--font-size-2', '0.8rem');
      document.documentElement.style.setProperty('--font-size-3', '0.8rem');
      document.documentElement.style.setProperty('--font-size-4', '1.5rem');
      document.documentElement.style.setProperty('--font-size-5', '1.5rem');
      document.documentElement.style.setProperty('--font-size-6', '1.5rem');
      document.documentElement.style.setProperty('--font-size-7', '2rem');
      document.documentElement.style.setProperty('--font-size-8', '2rem');
      document.documentElement.style.setProperty('--font-size-9', '2rem');
      document.documentElement.style.setProperty('--leading-1', '1.5');
      document.documentElement.style.setProperty('--leading-2', '1.65');
      this.loadFont();
    }
  }

  /**
   * onChange
   */
  async onChange() {
    if (this.$el.checked) {
      document.body.classList.add('dyslexia');
      localStorage.setItem('dyslexia', '1');
      this.loadFont();
      document.documentElement.style.setProperty('--font-size-1', '0.8rem');
      document.documentElement.style.setProperty('--font-size-2', '0.8rem');
      document.documentElement.style.setProperty('--font-size-3', '0.8rem');
      document.documentElement.style.setProperty('--font-size-4', '1.5rem');
      document.documentElement.style.setProperty('--font-size-5', '1.5rem');
      document.documentElement.style.setProperty('--font-size-6', '1.5rem');
      document.documentElement.style.setProperty('--font-size-7', '2rem');
      document.documentElement.style.setProperty('--font-size-8', '2rem');
      document.documentElement.style.setProperty('--font-size-9', '2rem');
      document.documentElement.style.setProperty('--leading-1', '1.5');
      document.documentElement.style.setProperty('--leading-2', '1.65');
    } else {
      document.body.classList.remove('dyslexia');
      localStorage.setItem('dyslexia', '0');
      document.documentElement.style.setProperty('--font-family', 'Unistra A');
      document.documentElement.style.removeProperty('--font-size-1');
      document.documentElement.style.removeProperty('--font-size-2');
      document.documentElement.style.removeProperty('--font-size-3');
      document.documentElement.style.removeProperty('--font-size-4');
      document.documentElement.style.removeProperty('--font-size-5');
      document.documentElement.style.removeProperty('--font-size-6');
      document.documentElement.style.removeProperty('--font-size-7');
      document.documentElement.style.removeProperty('--font-size-8');
      document.documentElement.style.removeProperty('--font-size-9');
      document.documentElement.style.setProperty('--leading-1', '1.1');
      document.documentElement.style.setProperty('--leading-2', '1.2');
    }
  }

  /**
   *
   */
  loadFont() {
    const font = new FontFace(
      'dyslexia',
      'url(/themes/custom/studiometa/static/fonts/OpenDyslexic-Regular.woff2)',
      { weight: '400' },
    );
    const fontBold = new FontFace(
      'dyslexia',
      'url(/themes/custom/studiometa/static/fonts/OpenDyslexic-Bold.woff2)',
      { weight: '700' },
    );

    Promise.all([font.load(), fontBold.load()]).then(function (loadedFonts) {
      loadedFonts.forEach(function (loadedFont) {
        document.fonts.add(loadedFont);
      });
      document.documentElement.style.setProperty('--font-family', 'dyslexia');
    });
  }
}
